import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.exam.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_EXAM_ASYNC: `${uid}.saveExamAsync`,
    SAVE_EXAM_SUCCESS: `${uid}.saveExamSuccess`,
    SAVE_EXAM_FAILURE: `${uid}.saveExamFailure`,
    CREATE_EXAM: `${uid}.createExam`
};

export { ActionTypes };
